import Button from '@lib/components/common/Button';
import IndexPage from '@lib/components/index-table/IndexPage';
import SPFProductSerialNumberCartIndexTable from './SPFProductSerialNumberCartIndexTable';
import store from '@lib/store/SparePartsFinderTextSearchBasketStore';
import SPFCartIndexHelper from '../../cart/SPFCartIndexHelper';

export default class SPFProductSerialNumberCartIndexPage extends IndexPage {

    static defaultProps = {
        tableComponentClass: SPFProductSerialNumberCartIndexTable,
        indexTablePagerVisible: false
    }

    constructor(props) {
        super(props);
    }

    renderFilterPanel = () => (
        <React.Fragment/>
    )

    renderHeader() {
        return <React.Fragment/>
    }

    buildIndexAPIRequestModel() {
        return {
            filter: this.props.createFilter()
        }
    }

    renderFooterActionButtons() {
        return (
            <Button
                theme={Button.Theme.BorderOnly}
                disabled={this.getSelectedRowIds().length === 0}
                onClick={this.onRemoveSelectedFromBasketClick}
            >
                {__('Remove selected')}
            </Button>
        )
    }

    onRemoveSelectedFromBasketClick = () => {
        var h = new SPFCartIndexHelper(store, this);
        h.onRemoveSelectedFromBasketClick();
    }
}